module.exports = __webpack_public_path__ + "img/funda-ai.5c143cbb.svg";